export default __webpack_public_path__ + "static/media/safeguard.a8fe6a03.mp4";